<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'devicegroup',
})
</script>
<template>
  <div class="flex">
  <a-card   style="width:20%;" class="margin-right">
    <template #title>
      <ClockCircleOutlined /> <span class="margin-left-xs">定时盘煤</span>
    </template>
    <ScannerSet/>
  </a-card>
  <a-card title="盘煤仪" class="flex1">
    <template  #extra>
       <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增 </a-button>
    </template>
    <a-table class="flex1" :dataSource="dataSource" :pagination="page"
    :loading="loading" :columns="columns" @change="pageChange" >
    <template #bodyCell="{ column, record,index }">
      <template v-if="column.key === 'DeviceGroupId'">
         {{ AutoData.FindName(datamodel,'DeviceGroupId',record.DeviceGroupId) }}
      </template>
      <template v-if="column.key === 'operation'">
        <a-button-group>

            <a-button v-if="auth.edit"  size="small" type="primary" @click="edit(record)">
                <EditOutlined /> 修改
            </a-button>
            <a-button v-if="auth.del"  size="small" type="primary" @click="del(record,index)">
                <DeleteOutlined /> 删除
            </a-button>
             <a-button  v-if="auth.edit"  size="small" type="primary" @click="start(record)">
                 启动盘煤
            </a-button>
          </a-button-group>
      </template>
    </template>
    </a-table>

    <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  </a-card>
  </div>
</template>

<script setup lang="ts" name="devicegroup">
import api from '@/utils/http/service'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import detail from './detail.vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import { PlusOutlined,EditOutlined,DeleteOutlined,ContainerOutlined,ClockCircleOutlined} from '@ant-design/icons-vue'
import ScannerSet from './scanerset.vue'
import { AutoData } from '@/utils/util'
import { message } from 'ant-design-vue'

  const auth:any=api.auth()
  const datamodel=ref<any>()//原始数据类型
  onMounted(()=>{
    api.scaner.model().then(res=>{
      if(res.state==1){
        datamodel.value=AutoData.InitModel(res.data)
        columns.value=AutoData.GetTableModel(datamodel.value,['ID','DeviceNo','DeviceName','DeviceGroupId'])
        var role=AutoData.GetFormModel(datamodel.value,['DeviceNo','DeviceName','Description','DeviceGroupId','DataUrl','SettingUrl'])
        role.DeviceGroupId.required=true
        role.DeviceGroupId.domtype='select'
        formRole.value=role
        getList()
      }
    })
  })

const searchVal:Record=ref({
  keyword:'',
})
const searchRule:Record=ref({
  keyword:{name:'关键字'}
})
const columns=ref<Array<object>>()
const page=ref<PageData>({
    current:1,
    pageSize:10,
    pageFlag:true,
    total:0,
    pageStatus:'more',
    currentKey: 'pageIndex',
    pageSizeKey: 'pageSize',
  })
  const search=(e):void=>{
    searchVal.value=e
    page.value.current=1
    getList()
  }
  const loading=ref<boolean>(false)
  const dataSource=ref<Array<any>>([])
  const getList=():void=>{
    loading.value=true
      api.scaner.list({pageIndex:page.value.current,pageSize:page.value.pageSize,...searchVal}).then(res => {
        loading.value=false
        if(res.state==1){
            dataSource.value=res.data.data
          page.value.total=res.data.records
          page.value.current=res.data.pageIndex
        }
      })
  }
  const pageChange=(e:anly)=>{
    page.value=e
    getList()
  }

const formModel:Record=ref({})
const formRole=ref({})
const formshow=ref<Boolean>(false)
const edit=(d)=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,d)
  formshow.value=true
}
const add=()=>{
  formModel.value=AutoData.GetDefaltModel(datamodel.value,{ID:0,MaxVolume:0})
  formshow.value=true
}
const del=(item,i)=>{
  api.scaner.del(item.ID).then(res=>{
    if(res.state==1){
      dataSource.value.splice(i,1)
    }
  })
}
const start=(item)=>{
  api.scaner.start(item.ID).then(res=>{
    if(res.state==1&&res.data==true){
      message.success('盘煤仪【'+item.DeviceName+'】已启动')
    }else{
      message.error('盘煤仪【'+item.DeviceName+'】启动失败.'+res.message)
    }
  })
}
const submit=(e:any)=>{
  api.scaner.add(e).then(res=>{
    if(res.state==1){
      formshow.value=false
      getList()
    }
  })
}
</script>
